import { AbstractMesh } from '@babylonjs/core';

export type BodyPartMetaData = {
  parentLabel: string;
  bodyPartId: string;
};

export default class BodyPart {
  // Unique identifier for this body part.
  public id: string;
  // Human readable name of body part for use in Text fields and search calls.
  public label: string;
  // Collection of meshes that make up this body part.
  public meshes: AbstractMesh[] | AbstractMesh;

  constructor(id: string, label: string, meshes: AbstractMesh[] | AbstractMesh, registry?: Map<number, BodyPart>) {
    this.id = id;
    this.label = label;
    this.meshes = meshes;

    if (Array.isArray(this.meshes)) {
      this.meshes.forEach((mesh) => {
        mesh.metadata = {
          ...(mesh.metadata ?? {}),
          parentLabel: label,
          bodyPartId: id,
        } as BodyPartMetaData;

        // Register mesh -> bodypart
        registry?.set(mesh.uniqueId, this);
      });
    }
  }
}
